import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_STOCK_BALANCE_HISTORIES_DETAIL_API_ID =
  'FETCH_STOCK_BALANCE_HISTORIES_DETAIL_API_ID';

const apiCall = createApiCall(
  FETCH_STOCK_BALANCE_HISTORIES_DETAIL_API_ID,
  ({ id, ...params }: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/stock-balance-histories/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
